/* A BOLINHA DE COR ESCOLHE NA VITRINE — [2026-08-26]
   Ordem dele, com o print da Stanley: "o seletor de cor já trocar de cor, aí no
   produto... ele troca de cor na própria home".

   O QUE ELA FAZ, em ordem: marca a bolinha, troca a foto do cartão pela foto da
   variante e reaponta o `data-variante` do botão Comprar. Sem isso a pessoa
   escolheria a cor e levaria outra — o defeito do A2 pela porta dos fundos.

   📏 A CONFIGURAÇÃO JÁ EXISTE NA LOJA. Conferido na API em 26/08: toda variante
     de cor já tem foto própria (Tokyo 2, Horizon 6, Porta Treco 5, Clássico
     Filetado 4). Não há trabalho de painel pendente para isto funcionar.

   🪤 DELEGADO NO `document`, NÃO NO CARTÃO. A grade é repintada por "carregar
     mais", por filtro e pela gaveta; ouvinte presto ao elemento morre no
     primeiro redesenho. É a lição de 24/08, e ela vale aqui igual.

   🪤 E NÃO CHAMA `preventDefault()` NO CARTÃO INTEIRO. O `.pc-cobre` é um link
     que cobre o cartão; a bolinha é IRMÃ dele, não filha. O `stopPropagation`
     existe só para o toque na bolinha não virar navegação. */
(function () {
  'use strict';

  function trocaFoto(cartao, url) {
    if (!url) return;
    var img = cartao.querySelector('.pc-foto img');
    if (!img) return;
    /* srcset venceria o src novo em silêncio: a foto não mudaria e não haveria
       erro nenhum. Some com ele antes de trocar. */
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = url;
  }

  /* 🔴 "CLICAR EM MARROM NÃO TROCA A IMAGEM NA HORA" — revisão dele, [2026-09-06].
     A troca era `img.src = url` e a foto da variante só era baixada no clique:
     o intervalo que ele viu é a rede. Agora as fotos das bolinhas de cada
     cartão são pré-carregadas quando o cartão entra na tela (200px antes), e
     o clique só troca o que já está no cache. Cartões que a grade repinta
     ("carregar mais", filtro) entram pelo observador de mutação — o de
     interseção sozinho só veria os do primeiro desenho. */
  var pre = new Set();
  function precarrega(cartao) {
    if (cartao.dataset.preCor) return;
    cartao.dataset.preCor = '1';
    cartao.querySelectorAll('.pc-cores button.pc-bola[data-foto]').forEach(function (b) {
      var url = b.dataset.foto;
      if (!url || pre.has(url)) return;
      pre.add(url);
      var im = new Image();
      im.decoding = 'async';
      im.src = url;
    });
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        precarrega(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '200px 0px' });
    var observa = function () {
      document.querySelectorAll('.pc:not([data-pre-cor])').forEach(function (c) { io.observe(c); });
    };
    observa();
    var agendado = false;
    new MutationObserver(function () {
      if (agendado) return;
      agendado = true;
      requestAnimationFrame(function () { agendado = false; observa(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('pointerover', function (ev) {
    var cartao = ev.target.closest && ev.target.closest('.pc');
    if (cartao) precarrega(cartao);
  }, { passive: true });

  document.addEventListener('click', function (ev) {
    var bola = ev.target.closest && ev.target.closest('.pc-cores button.pc-bola');
    if (!bola) return;
    var cartao = bola.closest('.pc');
    if (!cartao) return;

    ev.preventDefault();
    ev.stopPropagation();

    cartao.querySelectorAll('.pc-cores button.pc-bola').forEach(function (b) {
      var suaVez = b === bola;
      b.classList.toggle('on', suaVez);
      b.setAttribute('aria-pressed', suaVez ? 'true' : 'false');
    });

    trocaFoto(cartao, bola.dataset.foto);
    /* [2026-10-19] cartão do sem fio: o hover ACENDE na cor escolhida. Sem `data-acesa` a 2ª foto fica como está. */
    var acesa = cartao.querySelector('.pc-foto img.pc-2');
    if (acesa && bola.dataset.acesa) {
      acesa.removeAttribute('srcset');
      acesa.removeAttribute('sizes');
      acesa.src = bola.dataset.acesa;
    }

    var botao = cartao.querySelector('.pc-add');
    if (botao && bola.dataset.var) botao.dataset.variante = bola.dataset.var;
    if (botao && bola.dataset.junto) botao.dataset.junto = bola.dataset.junto; // 2ª sem fio: a Pisa da mesma cor vai junto
  }, false);
})();
